import { render, staticRenderFns } from "./ParentIclassReport.vue?vue&type=template&id=508024b3&scoped=true"
import script from "./ParentIclassReport.vue?vue&type=script&lang=js"
export * from "./ParentIclassReport.vue?vue&type=script&lang=js"
import style0 from "./ParentIclassReport.vue?vue&type=style&index=0&id=508024b3&prod&scoped=true&lang=css"
import style1 from "./ParentIclassReport.vue?vue&type=style&index=1&id=508024b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508024b3",
  null
  
)

export default component.exports